$(document).ready(function(){

  var products = [];
  var price_products = [];
  var qtys = [];
  let qty_item = {}
  var currentCurrency = "£";
  localBundleProducts();
  var sbd = $('.subscription_discount').val();
  if(sbd>0){
    var sbdp = 100-sbd;
  }else{
    var sbdp = 100;
  }

  $(document).on("change",".slide_round",function(){
    if ($(this).is(":checked")) {
      $('.span_org_price').addClass('hide_button');
      $('.span_sub_price').removeClass('hide_button');
      localStorage.setItem('subscription_option', 'yes');
    }else{
      $('.span_org_price').removeClass('hide_button');
      $('.span_sub_price').addClass('hide_button');
      localStorage.setItem('subscription_option', '');
    }
    updateBundleList();
  }); 
  
  $(document).on("click",".bundle_add",function(){
    var product_id = $(this).attr("product_id");
    $(".bundle_"+product_id).addClass('hide_button');
    $(".qty_"+product_id).removeClass('hide_button');
    $(".count_product_"+product_id).removeClass('hide_button');  
    if(products.indexOf(product_id) === -1){
      qtys[product_id] = 1;
      qty_item[product_id] = 1;
      products.push(product_id);
      localStorage.setItem('localproducts', JSON.stringify(products));
      localStorage.setItem('localqtys', JSON.stringify(qty_item));
    }
    updateBundleList();
    
  });
  
  $(document).on("click",".bundle_free",function(){
    var product_id = $(this).attr("product_id");  
   if (localStorage.getItem('free_product')) {
        // If free_product has a value, use free_product1 and add_option1
        localStorage.setItem('add_option1', 'added');
        localStorage.setItem('free_product1', product_id);
    } else {
        // Otherwise, use free_product and add_option
        localStorage.setItem('add_option', 'added');
        localStorage.setItem('free_product', product_id);
    }
    $('.free_full_size_list').addClass('dp_none');
    $('body').removeClass('body_overflow');
   
    updateBundleList();
    
  });

  $(document).on("click",".quantity__minus",function(){
    var product_id = $(this).attr("product_id");    
    var qty = $(this).next('input').val();
    if(qty>1){
      var nq = parseInt(qty)-1;
      $(this).next('input').val(nq);
      $('.cn_'+product_id).text(nq);
      $('.mpc_'+product_id).text(nq);
      qtys[product_id] = nq;
      qty_item[product_id] = nq;
      localStorage.setItem('localqtys', JSON.stringify(qty_item));
      updateCartPrice();
    }else{

      products = jQuery.grep(products, function(value) {
        return value != product_id;
      });
      $(".bundle_"+product_id).removeClass('hide_button');
      $(".qty_"+product_id).addClass('hide_button');
      $(".count_product_"+product_id).addClass('hide_button');  
      localStorage.setItem('localproducts', JSON.stringify(products));
      updateBundleList();
    }
  });

  $(document).on("click",".quantity__plus",function(){
    var product_id = $(this).attr("product_id");
    var qty = $(this).prev('input').val();
    var nq = parseInt(qty)+1;
    $(this).prev('input').val(nq);
    $('.cn_'+product_id).text(nq);
    $('.mpc_'+product_id).text(nq);
    qtys[product_id] = nq;
    qty_item[product_id] = nq;
    localStorage.setItem('localqtys', JSON.stringify(qty_item));
    updateCartPrice();
  });

  $(document).on("click",".icon_t",function(){
    var product_id = $(this).attr("product_id");
    products = jQuery.grep(products, function(value) {
      return value != product_id;
    });
    $(".bundle_"+product_id).removeClass('hide_button');
    $(".qty_"+product_id).addClass('hide_button');
    $(".qty_"+product_id+" input").val(1);
    $(".count_product_"+product_id).addClass('hide_button');  
    localStorage.setItem('localproducts', JSON.stringify(products));
    updateBundleList();
  });

  $(document).on("click",".add_bundle_cart",function(){
    if(products.length>=1){
      this.closest(".button-wrapper").classList.add("busy");
      var data = [];
      if(products.length==0 && localStorage.getItem('add_option')!='added'){
        for(let ii=0;ii<products.length;ii++){
          var variation = $(".variant_"+products[ii]).val();
          $("#dvariation").val(variation);
          $("#dquantity").val(qtys[products[ii]]);
          if ($('.slide_round').is(":checked")) {
            var vsp = $(".variant_sub_"+products[ii]).val();
            $( "#dselling_plan" ).prop( "disabled", false );
            $( "#dselling_plan" ).val(vsp);
          }
        }
        $("#freegift-name").remove();
        $(".direct-checkout").trigger('click');
      }else{
        var countset = 0;
        
        if(localStorage.getItem('add_option')=='added'){
          	
        	var pId = localStorage.getItem('free_product');
          	var variation = $(".variant_"+pId).val();
            let item = {}
            let properties = {}
            item['properties'] = {"_bundle":true,"_freegift":true}
            item['id'] = variation;
            item['quantity'] = 1;
          	$("#dvariation").val(variation);
            $("#dselling_plan").remove();
          	countset++;
          data.push(item);
        }
        if(localStorage.getItem('add_option1')=='added'){
          	
        	var pId = localStorage.getItem('free_product1');
          	var variation = $(".variant_"+pId).val();
            let item = {}
            let properties = {}
            item['properties'] = {"_bundle":true,"_freegift":true}
            item['id'] = variation;
            item['quantity'] = 1;
          	$("#dvariation").val(variation);
            $("#dselling_plan").remove();
          	countset++;
          data.push(item);
        }
        for(let ii=0;ii<products.length;ii++){
          var variation = $(".variant_"+products[ii]).val();
          let item = {}
          let properties = {}
          
          item['properties'] = {"_bundle":true}
          //item['properties'].push(properties);
          if(ii==products.length-1 && countset==0){
            $("#dvariation").val(variation);
            $("#dquantity").val(qtys[products[ii]]);
            if ($('.slide_round').is(":checked")) {
              var vsp = $(".variant_sub_"+products[ii]).val();
              $( "#dselling_plan" ).prop( "disabled", false );
              $( "#dselling_plan" ).val(vsp);
            }
            $("#freegift-name").remove();

            if ($('.slide_round').is(":checked")) {
              var vsp = $(".variant_sub_"+products[ii]).val();
              item['id'] = variation;
              item['quantity'] = qtys[products[ii]];
              item['selling_plan'] = vsp;
            }else{
              item['id'] = variation;
              item['quantity'] = qtys[products[ii]];
            }
          var check = localStorage.getItem("discountprice");
            var discountcode;
            if (check >= 7500 && check < 9000){
                item['discount_code'] = 'FREE PRODUCT OVER £60';
                discountcode = 'FREE PRODUCT OVER £60';
            }
            else if (check >= 9000){
               item['discount_code'] = 'Free Product Over 75';
              discountcode = 'Free Product Over 75'
            }
            window.sessionStorage.setItem("auto-apply-discount", discountcode);
            data.push(item);
           console.log(discountcode);
            //console.log(check);
             // console.log(item);
            /*
            if(amt < 75){
             
            }
            */
            
          }else{
            if ($('.slide_round').is(":checked")) {
              var vsp = $(".variant_sub_"+products[ii]).val();
              item['id'] = variation;
              item['quantity'] = qtys[products[ii]];
              item['selling_plan'] = vsp;
            }else{
              item['id'] = variation;
              item['quantity'] = qtys[products[ii]];
            }
             var check = localStorage.getItem("discountprice");
            if (check >= 7500 && check < 9000){
                item['discount_code'] = 'FREE PRODUCT OVER £60';
              discountcode = 'FREE PRODUCT OVER £60'
            }
            else if (check >= 9000){
              item['discount_code'] = 'Free Product Over 75';
              discountcode = 'Free Product Over 75'
            }
            window.sessionStorage.setItem("auto-apply-discount", discountcode);
            data.push(item);
          }
        }

        fetch('/cart/add.js', {
          body: JSON.stringify({items:data}),
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            "Accept": "application/json"
          },
          method: "post"
        }).then((response) => {
          return response.json();
        }).then((json) => {
          /* yay! our products were added - do something here to indicate to the user */
          products = [];
          updateBundleList();
          localStorage.setItem('localqtys', '');
          localStorage.setItem('localproducts', '');
          localStorage.setItem('add_option','');
          localStorage.setItem('free_product','');
          localStorage.setItem('free_product1','');
          localStorage.setItem('add_option1','');
          //window.location.href += "?cart=open";
          //window.location.reload();
          //return false;
          
            var auto_apply_discount_code = window.sessionStorage.getItem("auto-apply-discount");
             window.location = `/checkout?discount=${auto_apply_discount_code}`;
          //window.location=`/discount/${auto_apply_discount_code}?redirect=/checkout`;
         //  console.log(window.location);
          // window.location.href = "/checkout";  
          
          //setTimeout(function(){ $(".direct-checkout").trigger('click'); }, 2000);

        }).catch((err) => {
          /* uh oh, we have error. */
          console.error(err)
        });
      }
    }
  });

  function updateBundleList(){
    var price = 0;
	var dprice = 0;
    var add_first = localStorage.getItem('free_product');
    var add_second = localStorage.getItem('free_product1');
    var check = 0;
    if(localStorage.getItem('add_option')=='added'){
      var pCount = products.length+1;
    }else{
      var pCount = products.length;
    }
   	
    if(products.length>=1){
      $('.without_img_text').hide();
      $('.bundleproducts').html('');
      if(products.length<6){
        var cls = '';
        if(products.length<=3){
        	cls = 'hidemobile'; 
        }
        for(let jj = pCount; jj < 6; jj++){
          var empty = '';
          empty = empty+'<div class="product_box_1 '+cls+'">';
          empty = empty+'<div class="container"> ';
          empty = empty+'</div></div>';
          $('.bundleproducts').append(empty);
        }
      }
		var temp = 0;
      
      for(let ii=0;ii<products.length;ii++){
        var handle = $(".handle_"+products[ii]).val();
		var html ='';
        
        var p_price = $(".pprice_"+products[ii]).val();
        var p_title = $(".title_"+products[ii]).val().replace(" Default Title", "");
        var p_src = $(".feature_"+products[ii]).attr('src');
     //  console.log("THIS", $(".feature_"+products[ii])); 
        if(add_second!=products[ii]){
          if ($('.slide_round').prop('checked')==true){   
            price = price+(p_price*qtys[products[ii]]);
            price_products[products[ii]] = p_price;
            dprice = dprice+(((p_price*sbdp)/100)*qtys[products[ii]]);
          }else{
              price = price+(p_price*qtys[products[ii]]);
              price_products[products[ii]] = p_price;
          }
        }

        html = html+'<div class="product_box_1 product_box_'+products[ii]+'">';

        html = html+'<div class="container"> ';
        html = html+'<img src="'+p_src+'" alt="Avatar" class="image" style="width:100%">';
        if(add_second!=products[ii]){
          html = html+'<div class="top_qty"> <span class="icon_qty" product_id="'+products[ii]+'"><span class="mpc_'+products[ii]+'">'+qtys[products[ii]]+'</span></span></div>';
          html = html+'<div class="top_icon"> <span class="icon_t" product_id="'+products[ii]+'">x</span> </div></div>';
        }else{
            html = html+'<div class="top_free"> <span class="icon_free" product_id="'+products[ii]+'">Free</span> </div></div>';
        }

        html = html+'<div class="middle"><div class="text"><a href="#" class="full-unstyled-link">'+p_title+'</a></div></div></div>';
        $('.bundleproducts').prepend(html); 
        var amt = (price/100).toFixed(2);
		
        if(amt>=75 && localStorage.getItem('add_option')!='added'){
          $('.free_full_size_list').removeClass('dp_none');
          $('body').addClass('body_overflow');
        }else if((temp>0 || products.length==1) && temp==products.length-1 && amt<50){
		  
          products = jQuery.grep(products, function(value) {
            return value != add_second;
          });

          var empty = '';
          empty = empty+'<div class="product_box_1">';
          empty = empty+'<div class="container"> ';
          empty = empty+'</div></div>';
          if ($(".product_box_"+add_first)[0]){
            $(".first_free_product").remove();
            $('.bundleproducts').append(empty);
          }

          if ($(".product_box_"+add_second)[0]){
            $(".product_box_"+add_second).remove();
            $('.bundleproducts').append(empty);
          }

          localStorage.setItem('add_option','');
          localStorage.setItem('free_product','');
          localStorage.setItem('localproducts', JSON.stringify(products));   
        }

        if(amt>=90 && localStorage.getItem('add_option1')!='added'){

         $('.free_full_size_list').removeClass('dp_none');
          $('body').addClass('body_overflow');
          
        } else if((temp > 0 || products.length == 1) && temp==products.length-1 && amt < 75) {

          products = jQuery.grep(products, function(value) {
            return value != add_second;
          });

          var empty = '';
          empty = empty+'<div class="product_box_1">';
          empty = empty+'<div class="container"> ';
          empty = empty+'</div></div>';
          if ($(".product_box_"+add_second)[0]){
            $(".first_free_product1").remove();
            $('.bundleproducts').append(empty);
          }

          if ($(".product_box_"+add_second)[0]){
            $(".product_box_"+add_second).remove();
            $('.bundleproducts').append(empty);
          }

          localStorage.setItem('add_option1','');
          localStorage.setItem('free_product1','');
          localStorage.setItem('localproducts', JSON.stringify(products));   
        
          
        }
        
        $('.progress_right').removeClass('switch_img');

        var progress = 0;

        if(amt>=90){
          
          $('.progress_right').addClass('switch_img');
          $('.progress-bar').css({"background": "#3d3d3d", "width": "100%"});
        }else if(amt>=75){
          progress = parseInt(amt*1.06);
          $('.progress_right1').addClass('switch_img');
          $('.progress_right2').addClass('switch_img');
          $('.progress-bar').css({"background": "#3d3d3d", "width": progress+"%"});
        }else if(amt>=60){
          progress = parseInt(amt*0.80);
          $('.progress_right1').addClass('switch_img'); 
          $('.progress-bar').css({"background": "#3d3d3d", "width": progress+"%"});
        }else if(amt>0){
          progress = parseInt(amt*0.63);
            $('.progress-bar').css({"background": "#3d3d3d", "width":  progress+"%"});
        }else{
          $('.progress-bar').css({"background": "#3d3d3d", "width":  "0%"});
        }
        if(dprice>0){
          var total = '<del>'+currentCurrency+amt+'</del> <ins>'+currentCurrency+(dprice/100).toFixed(2)+'</ins>';
        }else{
          var total = '<ins>'+currentCurrency+amt+'</ins>';
        }
        //var total = currentCurrency+amt;
        $('.cart_price').html(total); 
        temp++;
        
      }
      if(localStorage.getItem('add_option')=='added' && !$(".first_free_product").length){
        var p_price = $(".pprice_"+add_first).val();
        var p_title = $(".title_"+add_first).val();
        var p_src = $(".feature_"+add_first).attr('src');
        var html = '';
        html = html+'<div class="product_box_1 first_free_product product_box_'+add_first+'">';

        html = html+'<div class="container"> ';
        html = html+'<img src="'+p_src+'" alt="Avatar" class="image" style="width:100%">';

        html = html+'<div class="top_free"> <span class="icon_free" product_id="'+add_first+'">Free</span> </div></div>';
showAlert("Free Product is added!");

        html = html+'<div class="middle"><div class="text"><a href="#" class="full-unstyled-link">'+p_title+'</a></div></div></div>';
        //console.log(p_title);
        //console.log(add_second)
        console.log("add_first");
		$('.bundleproducts').prepend(html);
      }
else if(localStorage.getItem('add_option1')=='added' && !$(".first_free_product1").length){
        var p_price = $(".pprice_"+add_second).val();
          var p_title = $(".title_"+add_second).val();
        var p_src = $(".feature_"+add_second).attr('src');
        var html = '';
        html = html+'<div class="product_box_1 first_free_product1 product_box_'+add_second+'">';

        html = html+'<div class="container"> ';
        html = html+'<img src="'+p_src+'" alt="Avatar" class="image" style="width:100%">';

        html = html+'<div class="top_free"> <span class="icon_free" product_id="'+add_second+'">Free</span> </div></div>';


        html = html+'<div class="middle"><div class="text"><a href="#" class="full-unstyled-link">'+p_title+'</a></div></div></div>';

  showAlert(" 2 Free Product is added!");
       // console.log(p_title);
        //console.log(add_second)
        //console.log("add_first");
		$('.bundleproducts').prepend(html);
      }
    }else{
      $('.without_img_text').show();
      $('.bundleproducts').html('');
      $('.dp_block').addClass('hide_button');
      $('.dp_block span span').text('1');
      $('.bundle_add').removeClass('hide_button');
      $('.add_qty').addClass('hide_button');
      $('.quantity__input').val(1);
      $('.progress-bar').css({"background": "#3d3d3d", "width":  "0%"});
      localStorage.setItem('add_option','');
      localStorage.setItem('add_option1','');
      localStorage.setItem('free_product','');
      localStorage.setItem('free_product1','');
      for(let jj=0;jj<6;jj++){
        var empty = '';
        var cls = '';
        if(jj>=3){
        	cls = 'hidemobile'; 
        }
        empty = empty+'<div class="product_box_1 '+cls+'">';
        empty = empty+'<div class="container"> ';
        empty = empty+'</div></div>';
        $('.bundleproducts').append(empty);
        var total = currentCurrency+"0.00";
        $('.cart_price').html(total); 
      }
    }
 localStorage.setItem("discountprice", price);
    console.log("updateBundleList()");
   // console.log(products);
    
  }

  function localBundleProducts(){
    var dr = getParameterValues('cart');
    if(dr=='open'){
      //$('#mini-cart').attr('open','open');
    
      $(".direct-checkout").trigger('click');
    }

    var localqtys = localStorage.getItem('localqtys');
    var localproducts = localStorage.getItem('localproducts');
    var sbo = localStorage.getItem('subscription_option');
    
    if(sbo != null && sbo=='yes'){
      $(".slide_round").prop("checked", true);
      $('.span_org_price').addClass('hide_button');
      $('.span_sub_price').removeClass('hide_button');
    }
    
    if (localproducts != null && localproducts!=''){
      var productsArray = JSON.parse(localproducts);
      var qtysArray = JSON.parse(localqtys);  
      for(let ii=0;ii<productsArray.length;ii++){
        qtys[productsArray[ii]] = qtysArray[productsArray[ii]];
        qty_item[productsArray[ii]] = qtysArray[productsArray[ii]] ;
        products.push(productsArray[ii]);
        $(".bundle_"+productsArray[ii]).addClass('hide_button');
        $(".qty_"+productsArray[ii]).removeClass('hide_button');
        $(".count_product_"+productsArray[ii]).removeClass('hide_button');  
        $(".qty_"+productsArray[ii]+" div input").val(qtysArray[productsArray[ii]]); 
        $(".cn_"+productsArray[ii]).text(qtysArray[productsArray[ii]]);  
      }
      updateBundleList();
    }
  }

  function updateCartPrice(){
    var price = 0;
    var dprice = 0;
    if(products.length>=1){
      for(let ii=0;ii<products.length;ii++){
        if (typeof price_products[products[ii]] !== "undefined") {
          price = price+(price_products[products[ii]]*qtys[products[ii]]);
          if ($('.slide_round').prop('checked')==true){ 
          dprice = dprice+(((price_products[products[ii]]*sbdp)/100)*qtys[products[ii]]);
          }
        }
      }
      var amt = (price/100).toFixed(2);
      var add_first = localStorage.getItem('free_product');
      var add_second = localStorage.getItem('free_product1');
      var temp =  0;
      if(amt>=74.99 && localStorage.getItem('add_option')!='added'){
        $('.free_full_size_list').removeClass('dp_none');
        $('body').addClass('body_overflow');
      }else if(amt<75  && localStorage.getItem('add_option')=='added'){
        temp++;
        
		updateBundleList();
      }

      if(amt>=90 && localStorage.getItem('add_option1')!='added'){
         $('.free_full_size_list').removeClass('dp_none');
        $('body').addClass('body_overflow');
      }else if(amt<90 && localStorage.getItem('add_option1')=='added'){
        temp++;
        updateBundleList();
      }
      
      $('.progress_right').removeClass('switch_img');
      
      if(amt>=90){
        $('.progress_right').addClass('switch_img');
        $('.progress-bar').css({"background": "#3d3d3d", "width": "100%"});
      }else if(amt>=75){
        progress = parseInt(amt*1.06);
        $('.progress_right1').addClass('switch_img');
        $('.progress_right2').addClass('switch_img');
        $('.progress-bar').css({"background": "#3d3d3d", "width": progress+"%"});
      }else if(amt>=60){
        progress = parseInt(amt*0.80);
        $('.progress_right1').addClass('switch_img'); 
        $('.progress-bar').css({"background": "#3d3d3d", "width": progress+"%"});
      }else if(amt>0){
        progress = parseInt(amt*0.63);
        $('.progress-bar').css({"background": "#3d3d3d", "width":  progress+"%"});
      }else{
        $('.progress-bar').css({"background": "#3d3d3d", "width":  "0%"});
      }
      if(dprice>0){
        var total = '<del>'+currentCurrency+amt+'</del> <ins>'+currentCurrency+(dprice/100).toFixed(2)+'</ins>';
      }else{
        var total = '<ins>'+currentCurrency+amt+'</ins>';
      }
      
      $('.cart_price').html(total); 
    }
    
  }
function showAlert(message) {
  // Create a new div element
  const alertDiv = document.createElement('div');
  alertDiv.className = 'alert-message';

  // Create a text node with the message
  const messageText = document.createTextNode(message);

  // Append the text node to the div
  alertDiv.appendChild(messageText);

  // Add the alert div to the document body
  document.body.appendChild(alertDiv);

  // Remove the alert div after a certain duration (e.g., 5 seconds)
  setTimeout(() => {
    alertDiv.remove();
  }, 1000);
}
  function getParameterValues(param) {  
    var url = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');  
    for (var i = 0; i < url.length; i++) {  
      var urlparam = url[i].split('=');  
      if (urlparam[0] == param) {  
        
        return urlparam[1];  
      }  
    }  
    return '';
  }  
  
});